(function (angular) {

    angular.module('app')
        .filter('timer', [function() {
            return function(seconds) {
                return new Date(1970, 0, 1).setSeconds(seconds);
            };
        }]);
})(angular);